export class HomeData {
    title = "Java Software Engineer";
    paragraph = "Hello, I'm <span> Anna </span>. Welcome my World.";
}

export class AboutData {
    paragraph = "I am a software engineer, java developer. I have been in IT for 2.5 years (commercial experience 2 years). " +
        "Assiduity, persistence, the ability to take responsibility and desire to learn helps me in the sphere of knowledge related to programming."
}

export class ContactData {
    email = "annecha562@gmail.com"
    phone = "89609888342"
    address = "Russia, Omsk"
    linkedin = "https://linkedin.com/mwlite/in/anna-kiseleva-a8706a237"
    github = "https://github.com/akiseleva-dev"
    instagram = "https://www.instagram.com/akiseleva99"
}